import React from 'react';
import { Navigate } from 'react-router-dom';

function PrivateRoute({ children }) {
  // Controlla se l'utente è autenticato
  const isAuthenticated = localStorage.getItem('token');

  // Se non è autenticato, reindirizza al login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Se è autenticato, mostra il componente figlio
  return children;
}

export default PrivateRoute; 